import React, { useState, useEffect } from 'react';
import intl from 'react-intl-universal';
import _debounce from 'lodash/debounce';
import { CircularProgress, makeStyles, TextField, Theme } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { searchMeetings } from 'utils/wampUtils';
import { MainConsumer } from 'mainProvider';
import { MeetingType } from 'context';
import { ReactComponent as SearchIcon } from '@lifesize/ux-assets/fonts/LS-Icons/SVG/search-rt.svg';

const SearchMeetings = () => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<MeetingType[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const classes = myStyles();

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    const doSearch = async () => {
      if (searchQuery && searchQuery.length) {
        setLoading(true);
        const options = await searchMeetings(searchQuery);
        setOptions(options);
        setLoading(false);
      } else {
        setOptions([]);
        setLoading(false);
      }
    };
    const debouncedSearch = _debounce(doSearch, 300);
    debouncedSearch();
  }, [searchQuery]);

  return (
    <MainConsumer>
      {({ setExistingMeeting, existingMeeting }) => {
        return (
          <Autocomplete
            className={classes.container}
            value={existingMeeting}
            getOptionLabel={(option) => option.displayName}
            getOptionSelected={(option, value) => option.displayName === value.displayName}
            id="meeting-search"
            loading={loading}
            noOptionsText={intl.get('meetingSearchInputNoOptions')}
            onClose={() => setOpen(false)}
            onChange={(event: React.ChangeEvent<{}>, value: MeetingType | null) => {
              if (setExistingMeeting) setExistingMeeting(value);
            }}
            onOpen={() => setOpen(true)}
            open={open}
            options={options && options.length ? options : []}
            popupIcon={<SearchIcon className="searchIcon" />}
            renderInput={(params) => (
              <TextField
                {...params}
                label={intl.get('meetingSearchInputLabel')}
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
                value={searchQuery}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  )
                }}
              />
            )}
          />
        );
      }}
    </MainConsumer>
  );
};

const myStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(2)
  }
}));

export default SearchMeetings;
